import { Create, SimpleForm, useRedirect } from "react-admin";
import { useState } from "react";
import BackButtonToolbar from "features/BackButtonToolbar";
import { CURRICULUMS, StudentServicePath } from "utils/constants";
import SaveForm from "./SaveForm";

const CreateCurriculum = () => {
  const [pdfDocumentId, setPdfDocumentId] = useState(null);
  const redirect = useRedirect();

  // A cloned plan carries the source's other fields in form state; only these may be sent.
  const handleSend = ({
    name,
    degreeId,
    specialityId,
    studyTypeId,
    validFrom,
    yearsOfStudy,
    admissionAfterEducationLevelId,
  }) => ({
    name,
    degreeId,
    specialityId,
    studyTypeId,
    validFrom,
    yearsOfStudy,
    admissionAfterEducationLevelId,
    pdfDocumentId,
  });

  return (
    <Create
      title="Създаване на учебен план"
      transform={handleSend}
      actions={<BackButtonToolbar />}
      // The plan is created empty, so send the user straight to where its contents are added.
      mutationOptions={{
        onSuccess: data => redirect("show", StudentServicePath + CURRICULUMS, data.id),
      }}
    >
      <SimpleForm>
        <SaveForm setPdfDocumentId={setPdfDocumentId} />
      </SimpleForm>
    </Create>
  );
};

export default CreateCurriculum;
